module.exports = __webpack_public_path__ + "static/media/undraw_updated_resume_u4fy 1.79f9fd7b.svg";